export default __webpack_public_path__ + "static/media/end-point.32faade6.png";